import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { ProgressBar } from 'settle-ui/components/ProgressBar/ProgressBar'
import { getOnboardingProgressValue } from './helpers/getOnboardingProgressValue/getOnboardingProgressValue'
import type { BusinessTypeEnum } from 'gql/types'

export interface OnboardingProgressBarProps {
  businessType: BusinessTypeEnum
}

export const OnboardingProgressBar: Settle.FC<OnboardingProgressBarProps> = ({ businessType, ...props }) => {
  const minimumRenderedValue = 12
  const { pathname } = useRouter()
  const { current, prev } = getOnboardingProgressValue({ pathname, businessType })
  const [value, setValue] = useState(prev >= minimumRenderedValue ? prev : minimumRenderedValue)

  useEffect(() => {
    setValue(current)
  }, [current])

  return (
    <ProgressBar
      {...props}
      value={value}
      variant="determinate"
      sx={(theme) => ({
        [theme.breakpoints.down('mobile')]: {
          top: 0,
          position: 'fixed',
          borderRadius: 0,
          width: '100vw',
          ml: theme.spacing(-3),
        },
        [theme.breakpoints.up('mobile')]: {
          margin: theme.spacing(0, 0, 2, 0),
          width: '380px',
        },
      })}
    />
  )
}
